import { React, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { RightOutlined } from '@ant-design/icons';
import {
  Space,
  SearchBar,
  AutoCenter,
  SpinLoading,
  ErrorBlock,
} from 'antd-mobile';
import { CarOutlined } from '@ant-design/icons';

const CarDescriptor = ({
  plateNumber,
  color,
  brand,
  model,
  year,
  displacement,
  isAllowMt,
  isAllowInsp,
  isShowInsp,
}) => {
  const navigate = useNavigate();

  const handleClick = () => {
    // 假设每个车辆信息都有唯一的 ID，这里使用 plateNumber 作为示例
    navigate(`/m/car/CarInfo`, {
      state: {
        plateNumber,
        color,
        brand,
        model,
        year,
        displacement,
        isAllowMt,
        isAllowInsp,
        isShowInsp,
      },
    });
  };

  return (
    <div className="car-container" onClick={handleClick}>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <CarOutlined
          width={'48px'}
          style={{
            fontSize: '24px',
            color: '#E60012',
            marginRight: '24px',
          }}
        />
        <div>
          <div
            className="text-body font-semibold mb-1"
            style={{ wordBreak: 'break-all' }}>
            {plateNumber}
          </div>
          <div
            className="text-sm font-normal"
            style={{
              wordBreak: 'break-all',
            }}>{`${color}／${brand}／${model}`}</div>
        </div>
      </div>
      <div>
        <RightOutlined style={{ color: '#A7A9AC' }} />
      </div>
    </div>
  );
};

const CarCollection = (props) => {
  const { carList } = props;
  return (
    <div>
      <div className="text-body font-normal mb-2">
        共有 {carList.length} 筆資料
      </div>{' '}
      {carList.length === 0 ? (
        <AutoCenter className="mt-8">
          <ErrorBlock status="empty" title="查無車輛資料" description={null} />
        </AutoCenter>
      ) : (
        <>
          {/* 显示车辆信息总数 */}
          {carList.map((car, index) => (
            <CarDescriptor
              key={index}
              plateNumber={car.car}
              color={car.color}
              brand={car.brand}
              model={car.category}
              year={car.year}
              displacement={car.displacement}
              isAllowMt={car.is_allow_mt}
              isAllowInsp={car.is_allow_insp}
              isShowInsp={car.is_show_insp}
            />
          ))}
        </>
      )}
    </div>
  );
};

const CarList = ({ carList }) => {
  const [filteredCarList, setFilteredCarList] = useState(carList);

  // 根據搜尋字串找出符合的車輛
  const handleSearch = (value) => {
    const newList = carList.filter((car) => {
      return (
        car.car.toLowerCase().includes(value.toLowerCase()) ||
        car.brand.toLowerCase().includes(value.toLowerCase())
      );
    });
    setFilteredCarList(newList);
  };

  return (
    <div className="main-container">
      <Space block direction="vertical" style={{ '--gap': '32px' }}>
        <Space block direction="vertical" style={{ '--gap': '8px' }}>
          <div className="subheading font-bold pd-1">車輛查詢</div>
          <SearchBar
            className="custom-search-bar"
            placeholder="車牌號碼、品牌"
            showCancelButton
            style={{
              '--border-radius': '8px',
              '--background': '#ffffff',
              '--height': '48px',
              '--padding-left': '12px',
            }}
            onChange={(value) => {
              if (value === '') {
                setFilteredCarList(carList);
              } else {
                handleSearch(value);
              }
            }}
          />
        </Space>
        <CarCollection carList={filteredCarList}></CarCollection>
      </Space>
    </div>
  );
};

export default CarList;
